import { TerminalConsole } from "@/components/TerminalConsole";
import { MonoLabel, StatusDot } from "@/components/primitives";
import { useSEO } from "@/lib/useSEO";
import { PageShell } from "@/components/PageShell";

export default function TerminalPage() {
  useSEO({
    title: "Terminal — Consequence Terminal | Consequence Protocol",
    description:
      "Enter the Consequence Terminal — an interactive command interface for exploring the protocol’s outcome registry, reputation engine, and verification layer (simulated).",
    path: "/terminal",
  });

  return (
    <PageShell testId="page-terminal">
      <section className="container-t flex h-[calc(100svh-8rem)] min-h-[520px] flex-col py-8">
        <div className="panel scanlines hud-corners flex h-full flex-col overflow-hidden" data-testid="terminal-window">
          <div className="flex items-center justify-between border-b border-line px-4 py-3">
            <div className="flex items-center gap-3">
              <span className="flex gap-1.5" aria-hidden="true">
                <span className="h-2.5 w-2.5 rounded-full border border-error/60" />
                <span className="h-2.5 w-2.5 rounded-full border border-warn/60" />
                <span className="h-2.5 w-2.5 rounded-full border border-success/60" />
              </span>
              <MonoLabel className="text-ink/90">Consequence Terminal</MonoLabel>
              <MonoLabel className="hidden text-[8px] sm:block">VISITOR SESSION · SIMULATED</MonoLabel>
            </div>
            <StatusDot tone="success" label="Network online" testId="terminal-network-status" />
          </div>
          <TerminalConsole />
        </div>
        <p className="mt-4 text-center">
          <MonoLabel className="text-[8px] text-dim/60">
            Simulated environment — command responses are generated locally and query no blockchain
          </MonoLabel>
        </p>
      </section>
    </PageShell>
  );
}
